// Mock data for EDS Electromenager store

export const STORE_INFO = {
  name: "EDS ELECTROMENAGER",
  shortName: "EDS",
  tagline: "ELECTROMENAGER · DEPANNAGE · SERVICE",
  address: "304 Av. de la Capelette, 13010 Marseille",
  phone: "09.54.11.87.89",
  email: "zeidelectromenager@gmail.com",
  siret: "945 132 488 00012",
  hours: [
    { day: "Lundi", time: "09h00 - 18h00" },
    { day: "Mardi", time: "09h00 - 18h00" },
    { day: "Mercredi", time: "09h00 - 18h00" },
    { day: "Jeudi", time: "09h00 - 18h00" },
    { day: "Vendredi", time: "09h00 - 18h00" },
    { day: "Samedi", time: "09h00 - 18h00" },
    { day: "Dimanche", time: "Fermé" },
  ],
  storePhoto: "https://customer-assets.emergentagent.com/job_3d524ab6-b327-41ed-9376-fac656ee8389/artifacts/dhy1exq2_IMG_0662.jpeg",
  socials: { facebook: "#", instagram: "#", tiktok: "#" },
};

export const CATEGORIES = [
  { id: "refrigerateur", name: "Réfrigérateurs", slug: "refrigerateur", icon: "Refrigerator", image: "https://images.unsplash.com/photo-1721613877687-c9099b698faa" },
  { id: "lave-linge", name: "Lave-linge", slug: "lave-linge", icon: "WashingMachine", image: "https://images.unsplash.com/photo-1626806819282-2c1dc01a5e0c" },
  { id: "seche-linge", name: "Sèche-linge", slug: "seche-linge", icon: "Wind", image: "https://images.unsplash.com/photo-1626806787461-102c1bfaaea1" },
  { id: "cuisson", name: "Cuisson & Four", slug: "cuisson", icon: "CookingPot", image: "https://images.unsplash.com/photo-1596552183299-000ef779e88d" },
  { id: "lave-vaisselle", name: "Lave-vaisselle", slug: "lave-vaisselle", icon: "UtensilsCrossed", image: "https://images.unsplash.com/photo-1620568400263-6f1cf95b9e30" },
  { id: "tv-video", name: "TV & Image", slug: "tv-video", icon: "Tv", image: "https://images.unsplash.com/photo-1646861039459-fd9e3aabf3fb" },
  { id: "son", name: "Son & Hifi", slug: "son", icon: "Speaker", image: "https://images.unsplash.com/photo-1531104985437-603d6490e6d4" },
  { id: "petit-electromenager", name: "Petit Électroménager", slug: "petit-electromenager", icon: "Coffee", image: "https://images.unsplash.com/photo-1620807773206-49c1f2957417" },
  { id: "occasion", name: "Occasion", slug: "occasion", icon: "Tag", image: "https://images.unsplash.com/photo-1585659722983-3a675dabf23d" },
];

export const BRANDS = [
  "Midea", "Samsung", "Siemens", "Bosch", "Philips", "Brandt", "Candy", "Vedette",
  "Haier", "Beko", "Whirlpool", "Indesit", "Hotpoint", "LG", "Electrolux",
];

export const PRODUCTS = [
  {
    id: "midea-fridge-401", sku: "MIDEA-MDRB521MTE-401",
    name: "MIDEA Space Master Réfrigérateur combiné 401L Inox",
    brand: "Midea", category: "refrigerateur", price: 435, oldPrice: 599, discount: 27,
    condition: "Neuf", stock: 5, isNew: true, isPromo: true, isFeatured: true,
    image: "https://customer-assets.emergentagent.com/job_appliance-capelette/artifacts/x98kxvei_f124e8e2-5ba6-4cfb-b653-1a31d74fb33d.webp",
    gallery: [
      "https://customer-assets.emergentagent.com/job_appliance-capelette/artifacts/x98kxvei_f124e8e2-5ba6-4cfb-b653-1a31d74fb33d.webp",
      "https://customer-assets.emergentagent.com/job_appliance-capelette/artifacts/j4fdnru5_012fac4a-7f12-4ad2-9d83-7c6ac6a71a46.webp",
      "https://customer-assets.emergentagent.com/job_appliance-capelette/artifacts/odi5d7ys_5b4040b9-d6e2-45cb-8377-4a95cf9e6099.webp",
      "https://customer-assets.emergentagent.com/job_appliance-capelette/artifacts/gbho64ks_0ed7bee7-5f76-4b61-ba40-5b401d08b15f.webp",
    ],
    description: "Réfrigérateur combiné Midea Space Master 401 L, Inverter Compressor garantie 12 ans, ingénierie allemande. Platinum Fresh, Soft Light Panel, Maxx Fresh Zone (+47%), Maxx Freeze Zone 353 mm. Design inox.",
    specs: { "Capacité totale": "401 L", "Type": "Combiné 2 portes", "Technologie": "Inverter Compressor", "Garantie compresseur": "12 ans", "Anti-bactéries": "Platinum Fresh", "Certification": "German Engineering", "Couleur": "Inox", "État": "Neuf", "Garantie": "Constructeur" },
  },
  {
    id: "midea-dishwasher-ion", sku: "MIDEA-MFD60S150-ION",
    name: "MIDEA Ion Dishfresh Lave-vaisselle 14 couverts Inox connecté",
    brand: "Midea", category: "lave-vaisselle", price: 340, oldPrice: 499, discount: 32,
    condition: "Neuf", stock: 6, isNew: true, isPromo: true, isFeatured: true,
    image: "https://customer-assets.emergentagent.com/job_appliance-capelette/artifacts/hirtev86_cb47641e-0065-45b8-a884-fb85fd420c8f.webp",
    gallery: ["https://customer-assets.emergentagent.com/job_appliance-capelette/artifacts/hirtev86_cb47641e-0065-45b8-a884-fb85fd420c8f.webp"],
    description: "Lave-vaisselle Midea Ion Dishfresh avec technologie Golden Hygiene qui élimine 99,9% des bactéries. Compatible SmartHome Alexa & Google Home, programmes HygieneCare+ et MachineCare+.",
    specs: { "Couverts": "14", "Hygiène": "Golden Hygiene 99,9%", "Connectivité": "Wi-Fi · Alexa · Google Home", "Type": "Pose libre", "Couleur": "Inox", "État": "Neuf", "Garantie": "Constructeur" },
  },
  {
    id: "occ-ll-indesit-9", sku: "OCC-IND-LL9-150",
    name: "INDESIT Lave-linge 9kg A++ EcoTime — Occasion",
    brand: "Indesit", category: "lave-linge", price: 150, oldPrice: 449, discount: 67,
    condition: "Occasion", stock: 1, isNew: false, isPromo: true, isFeatured: false,
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/4sjrvdk9_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%284%29.jpeg",
    gallery: ["https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/4sjrvdk9_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%284%29.jpeg"],
    description: "Lave-linge Indesit 9 kg classe A++, technologie EcoTime & Energy Saver, Water Balance. Reconditionné en atelier, joints et tambour vérifiés.",
    specs: { "Capacité": "9 kg", "Classe énergie": "A++", "Programmes": "14", "Technologie": "EcoTime / Energy Saver", "État": "Reconditionné", "Garantie": "4 mois" },
  },
  {
    id: "occ-ll-hotpoint-aqualtis", sku: "OCC-HP-AQUALTIS-170",
    name: "HOTPOINT ARISTON Aqualtis Lave-linge premium — Occasion",
    brand: "Hotpoint", category: "lave-linge", price: 170, oldPrice: 599, discount: 72,
    condition: "Occasion", stock: 1, isNew: false, isPromo: true, isFeatured: false,
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/ymg7gc3p_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%287%29.jpeg",
    gallery: ["https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/ymg7gc3p_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%287%29.jpeg"],
    description: "Lave-linge Hotpoint Ariston Aqualtis, gamme premium, écran LCD, programmes personnalisés M1/M2/M3. Design gris élégant, révisé.",
    specs: { "Gamme": "Aqualtis Premium", "Écran": "LCD", "Type": "Frontal", "État": "Reconditionné", "Garantie": "4 mois" },
  },
  {
    id: "occ-ll-whirlpool-9-silence", sku: "OCC-WHIRL-9SS-180",
    name: "WHIRLPOOL 6ème Sens 9kg Supreme Silence — Occasion",
    brand: "Whirlpool", category: "lave-linge", price: 180, oldPrice: 649, discount: 72,
    condition: "Occasion", stock: 1, isNew: false, isPromo: true, isFeatured: false,
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/988iz5rg_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%286%29.jpeg",
    gallery: ["https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/988iz5rg_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%286%29.jpeg"],
    description: "Lave-linge Whirlpool 9 kg technologie 6ème Sens, Auto Cleaning, HeatPump Supreme Silence. Reconditionné.",
    specs: { "Capacité": "9 kg", "Technologie": "6ème Sens · Auto Cleaning", "Silence": "Supreme Silence (HeatPump)", "État": "Reconditionné", "Garantie": "4 mois" },
  },
  {
    id: "occ-ll-samsung-8", sku: "OCC-SAM-LL8-180",
    name: "SAMSUNG Lave-linge frontal 8kg Multi-programmes — Occasion",
    brand: "Samsung", category: "lave-linge", price: 180, oldPrice: 499, discount: 64,
    condition: "Occasion", stock: 1, isNew: false, isPromo: true, isFeatured: false,
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/cnhpwa2p_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%285%29.jpeg",
    gallery: ["https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/cnhpwa2p_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%285%29.jpeg"],
    description: "Lave-linge Samsung 8 kg avec programmes Bébé Coton, Sport, Laine, 15' Express, Quotidien, Jeans, Couleurs. Écran LED, révisé et testé.",
    specs: { "Capacité": "8 kg", "Type": "Frontal", "Programmes": "Coton / Sport / Laine / Express / Bébé", "Écran": "LED", "État": "Reconditionné", "Garantie": "4 mois" },
  },
  {
    id: "occ-ll-electrolux-tm", sku: "OCC-ELX-TM-160",
    name: "ELECTROLUX TimeManager Lave-linge — Occasion",
    brand: "Electrolux", category: "lave-linge", price: 160, oldPrice: 479, discount: 67,
    condition: "Occasion", stock: 1, isNew: false, isPromo: true, isFeatured: false,
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/drdlst18_WhatsApp%20Image%202026-08-08%20at%2013.00.49.jpeg",
    gallery: ["https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/drdlst18_WhatsApp%20Image%202026-08-08%20at%2013.00.49.jpeg"],
    description: "Lave-linge Electrolux 7 kg technologie TimeManager qui ajuste la durée selon la charge. Programmes Coton/Éco, Synthétiques, Délicats, Laine, Soie. Reconditionné.",
    specs: { "Capacité": "7 kg", "Technologie": "TimeManager", "Essorage": "1400 tr/min", "État": "Reconditionné", "Garantie": "4 mois" },
  },
  {
    id: "occ-ll-vedette-silence-12", sku: "OCC-VED-LFVC024W-200",
    name: "VEDETTE Silence LFVC024W Lave-linge 12kg 1400 tr/min — Occasion",
    brand: "Vedette", category: "lave-linge", price: 200, oldPrice: 599, discount: 67,
    condition: "Occasion", stock: 1, isNew: false, isPromo: true, isFeatured: false,
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/as1wz4lv_WhatsApp%20Image%202026-08-08%20at%2013.00.47.jpeg",
    gallery: ["https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/as1wz4lv_WhatsApp%20Image%202026-08-08%20at%2013.00.47.jpeg"],
    description: "Lave-linge Vedette Silence 12 kg, essorage 1400 tr/min. Programmes Hygiène, Coton, Éco 40-60, Rapide 60, Express, Synthétiques, Laine, Délicat. Écran LCD, très silencieux, reconditionné.",
    specs: { "Capacité": "12 kg", "Essorage": "1400 tr/min", "Silence": "Vedette Silence", "État": "Reconditionné", "Garantie": "4 mois" },
  },
  {
    id: "occ-ll-conti-cell9140", sku: "OCC-CE-CELL9140DW-180",
    name: "CONTINENTAL EDISON CELL9140DW Lave-linge 9kg 1400 tr/min A+ — Occasion",
    brand: "Continental Edison", category: "lave-linge", price: 180, oldPrice: 499, discount: 64,
    condition: "Occasion", stock: 1, isNew: false, isPromo: true, isFeatured: false,
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/b9pt9562_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%281%29.jpeg",
    gallery: ["https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/b9pt9562_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%281%29.jpeg"],
    description: "Lave-linge Continental Edison 9 kg, essorage 1400 tr/min, classe A+. Écran digital, multiples programmes, départ différé. Reconditionné et testé.",
    specs: { "Capacité": "9 kg", "Essorage": "1400 tr/min", "Classe énergie": "A+", "État": "Reconditionné", "Garantie": "4 mois" },
  },
  {
    id: "occ-ll-lg-11-aiwash", sku: "OCC-LG-AI11-200",
    name: "LG AI Wash Lave-linge 11kg vapeur anti-allergie — Occasion",
    brand: "LG", category: "lave-linge", price: 200, oldPrice: 799, discount: 75,
    condition: "Occasion", stock: 1, isNew: false, isPromo: true, isFeatured: false,
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/mgn5j9pp_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%282%29.jpeg",
    gallery: ["https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/mgn5j9pp_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%282%29.jpeg"],
    description: "Lave-linge LG 11 kg avec technologie AI Wash (dosage automatique intelligent), cycle vapeur, anti-allergie, Rapide 14 min, Couette, Mix 40°C. Grande capacité familiale, reconditionné.",
    specs: { "Capacité": "11 kg", "Technologie": "AI Wash · Vapeur", "Fonctions": "Anti-allergie · Rapide 14 · Couette", "État": "Reconditionné", "Garantie": "4 mois" },
  },
  {
    id: "occ-ll-whirl-freshcare-8", sku: "OCC-WHIRL-FRESH-190",
    name: "WHIRLPOOL FreshCare+ Lave-linge 8kg — Occasion",
    brand: "Whirlpool", category: "lave-linge", price: 190, oldPrice: 549, discount: 65,
    condition: "Occasion", stock: 1, isNew: false, isPromo: true, isFeatured: false,
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/a4rhwuww_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%283%29.jpeg",
    gallery: ["https://customer-assets-rejwkqb3.emergentagent.net/job_appliance-capelette/artifacts/a4rhwuww_WhatsApp%20Image%202026-08-08%20at%2013.00.48%20%283%29.jpeg"],
    description: "Lave-linge Whirlpool 8 kg avec technologie FreshCare+ qui garde le linge frais après la fin du cycle. Programmes Coton, Synthétiques, Mixte, Blanc, Sport, Couettes, Jeans, Rapide 30. Reconditionné.",
    specs: { "Capacité": "8 kg", "Technologie": "FreshCare+", "État": "Reconditionné", "Garantie": "4 mois" },
  },
];

export const SERVICES = [
  { icon: "Truck", title: "Livraison rapide", text: "Livraison à domicile sur Marseille et alentours sous 48h." },
  { icon: "Wrench", title: "Dépannage à domicile", text: "Nos techniciens interviennent chez vous pour toutes vos pannes." },
  { icon: "ShieldCheck", title: "Garantie constructeur", text: "Tous nos produits neufs sont garantis constructeur." },
  { icon: "Store", title: "Paiement en magasin", text: "Réservez en ligne, payez sur place au magasin." },
];

// Delivery pricing grid
export const DELIVERY_ZONES = [
  {
    id: "marseille",
    label: "Livraison Marseille",
    sub: "1er → 16e arrondissements · zone urbaine complète",
    price: 30,
    icon: "Building2",
    color: "#3b82f6",
  },
  {
    id: "dep13",
    label: "Livraison Département 13",
    sub: "Bouches-du-Rhône · hors Marseille intra-muros",
    price: 60,
    icon: "Map",
    color: "#f59e0b",
  },
];

export const DELIVERY_EXTRAS = {
  americanFridgeSurcharge: 60, // + 60€ pour réfrigérateurs américains / grandes dimensions
  perFloorNoElevator: 5,       // + 5€ par étage au-delà du RDC quand pas d'ascenseur
};

// Extensions de garantie optionnelles (au-delà de la garantie constructeur)
export const WARRANTY_EXTENSIONS = [
  { id: "none", label: "Aucune extension", months: 0, price: 0 },
  { id: "ext2",  label: "Extension 2 mois",  months: 2,  price: 30 },
  { id: "ext6",  label: "Extension 6 mois",  months: 6,  price: 80 },
  { id: "ext12", label: "Extension 12 mois", months: 12, price: 120 },
];

export const NEWS = [
  { id: "n1", title: "Pourquoi acheter en occasion reconditionnée ?", excerpt: "Écologique et économique, l'occasion permet d'équiper votre foyer sans exploser le budget.", date: "20 Juin 2025", image: "https://images.unsplash.com/photo-1585659722983-3a675dabf23d" },
  { id: "n2", title: "Les tendances électroménager 2025", excerpt: "Découvrez les nouveautés connectées et écoresponsables de l'année.", date: "12 Juin 2025", image: "https://images.unsplash.com/photo-1556911220-bff31c812dba" },
  { id: "n3", title: "Comment bien choisir son réfrigérateur ?", excerpt: "Nos conseils pour trouver le frigo idéal selon la taille de votre famille.", date: "05 Juin 2025", image: "https://images.unsplash.com/photo-1484154218962-a197022b5858" },
];
